const prefix = 'SYSTEM_PROPERTY/';

export const GET_ALL_SYSTEM_PROPERTY = `${prefix}GET_ALL_SYSTEM_PROPERTY`;
export const SET_LOADING = `${prefix}SET_LOADING`;
export const SET_SYSTEM_PROPERTY = `${prefix}SET_SYSTEM_PROPERTY`;

export const getAllSystemProperties = () => ({ type: GET_ALL_SYSTEM_PROPERTY });
